module.exports = __webpack_public_path__ + "img/banner.ba1cb69b.png";